export default function navigation($) {
    const activeClass = 'item-active';
    let $navigation = $('.navigation--primary');
    let $subNavigation = $('.navigation--secondary');

    if ( $('.navigation__item__current').length ) {
        var currentGroup = $('.navigation__item__current').parent('.navigation__group');
        var parent = currentGroup.data('group-parent');

        var primaryNavItem = $navigation.find('li a[data-group="' + parent + '"]');

        if ( primaryNavItem.length ) {
            primaryNavItem.addClass('item-current');
        } else {
            console.log(false);
        }
    }

    $(document).on('click', `.navigation--primary a:not(.${activeClass}, [rel="home"])`, function(e) {
        e.preventDefault();
        let $el = $(this);

        $('a.item-active', $navigation).removeClass(activeClass)
        $('.navigation__group', $subNavigation).removeClass('open');

        $el.addClass(activeClass);

        $(`.${$el.data('group')}-menu`, $subNavigation).addClass('open');
        $subNavigation.addClass('open');
		$navigation.addClass('nav-open');

    });

    $(document).on('click', `.navigation--primary li a.${activeClass}`, function(e) {
        e.preventDefault();
        $(this).removeClass(activeClass);

        $subNavigation.removeClass('open');
		$navigation.removeClass('nav-open');
    });

	// $(document).ready(function() {
	// 	if( $('body').hasClass('page-template-page-products') ) {
	// 		$subNavigation.addClass('open');
	// 		$('.products-menu').addClass('open');
	// 	}
	// });
};
